/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFilePresentationShortcut = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M4 2v12h2V4h7v5h5v11H8v2h12V7.586L14.414 2zm12.586 5H15V5.414zM8.5 14.5a3.5 3.5 0 0 1 3-3.465v6.93a3.5 3.5 0 0 1-3-3.465zm4-.5v-2.965A3.503 3.503 0 0 1 15.465 14zm.707 1h2.258a3.483 3.483 0 0 1-.662 1.596zm-.707.707 1.596 1.596a3.483 3.483 0 0 1-1.596.662zM12 10a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9z" />
        <path d="m1 16 1.474 1.474c-.573.66-.753 1.236-.753 1.236C.459 22.564 5.019 23 5.019 23c-2.609-1.67-1.942-2.876-.672-3.653L6 21v-5z" />
      </g>
    </g>
  </Icon>
);
export { SvgFilePresentationShortcut as FilePresentationShortcut };
